const resultFunction = (availableAssets) => ({
  ...(availableAssets.bitcointestnet && {
    [availableAssets.bitcoin?.name]: availableAssets.bitcointestnet,
  }),
  ...(availableAssets.ethereumsepolia && {
    [availableAssets.ethereum?.name]: availableAssets.ethereumsepolia,
  }),
})

const testnetAssetsSelectorDefinition = {
  id: 'testnetAssets',
  resultFunction,
  dependencies: [{ module: 'assets', selector: 'all' }],
}

export default testnetAssetsSelectorDefinition
